import React, { createContext, useState } from "react";
import { IdUsuario } from "../../utils/localStorage.util";

const LoginContext = createContext();

const LoginProvider = ({ children }) => {
  const [dadosLogin, setDadosLogin] = useState(() => {
    const idUsuario = IdUsuario.getUserId();
    return {
      status: idUsuario ? "ok" : "",
      email: "",
      tipoCadastroPlanTribKey: idUsuario ? "I" : "",
      idUsuario: idUsuario ?? "",
    };
  });

  return (
    <LoginContext.Provider value={{ dadosLogin, setDadosLogin }}>
      {children}
    </LoginContext.Provider>
  );
};

export { LoginContext, LoginProvider };
